/**
 * Datos de ejemplo para revisar el informe sin credenciales reales.
 * Se activa con ?demo=1 o con el boton "Cargar demo" de la barra de config.
 */

const DAY = 86400000

const PIPELINES = [
  {
    id: 'pl_ventas',
    name: 'Ventas directas',
    stages: [
      { id: 'st_nuevo', name: 'Nuevo lead' },
      { id: 'st_contacto', name: 'Primer contacto' },
      { id: 'st_cita', name: 'Cita agendada' },
      { id: 'st_propuesta', name: 'Propuesta enviada' },
      { id: 'st_cierre', name: 'Cierre' },
    ],
  },
  {
    id: 'pl_referidos',
    name: 'Referidos',
    stages: [
      { id: 'rf_nuevo', name: 'Referido recibido' },
      { id: 'rf_valida', name: 'Validacion' },
      { id: 'rf_cierre', name: 'Cierre' },
    ],
  },
  {
    id: 'pl_reactivacion',
    name: 'Reactivacion base fria',
    stages: [
      { id: 'rc_nuevo', name: 'Por contactar' },
      { id: 'rc_interes', name: 'Muestra interes' },
      { id: 'rc_cierre', name: 'Cierre' },
    ],
  },
]

const NOMBRES = [
  'Maria Uribe', 'Carlos Andrade', 'Lucia Pena', 'Jorge Salazar', 'Andrea Mora',
  'Diego Castillo', 'Paula Jimenez', 'Ruben Ortega', 'Sofia Cordova', 'Marcos Vera',
  'Elena Ruiz', 'Tomas Bravo', 'Valeria Nunez', 'Ignacio Leon', 'Camila Rojas',
  'Fernando Paz', 'Gabriela Silva', 'Hector Mena', 'Isabel Tapia', 'Julio Ramos',
]
const ORIGENES = ['Facebook Ads', 'Google Ads', 'Referido', 'Formulario web', 'WhatsApp', 'Landing page']
const USUARIOS = ['usr_ana', 'usr_luis', 'usr_marta', null, null]

// Generador determinista para que el demo no cambie en cada recarga.
function rng(seed) {
  let s = seed
  return () => {
    s = (s * 1664525 + 1013904223) % 4294967296
    return s / 4294967296
  }
}

export function demoData(now = Date.now()) {
  const r = rng(20260831)
  const pick = (arr) => arr[Math.floor(r() * arr.length)]
  const ago = (d) => new Date(now - d * DAY).toISOString()

  const contacts = []
  const opportunities = []

  for (let i = 0; i < 120; i += 1) {
    const id = `ct_${i}`
    const created = Math.floor(r() * 120) + 1
    const updated = Math.max(0, created - Math.floor(r() * created))
    contacts.push({
      id,
      firstName: pick(NOMBRES).split(' ')[0],
      lastName: pick(NOMBRES).split(' ')[1],
      email: `lead${i}@ejemplo.com`,
      phone: `+5939${String(10000000 + i).slice(0, 8)}`,
      source: pick(ORIGENES),
      tags: r() > 0.6 ? ['campana-agosto'] : [],
      assignedTo: pick(USUARIOS),
      dateAdded: ago(created),
      dateUpdated: ago(updated),
    })

    // ~55% de los contactos tienen oportunidad.
    if (r() > 0.45) {
      const pipeline = pick(PIPELINES)
      const stage = pipeline.stages[Math.floor(r() * (pipeline.stages.length - 1))]
      const oppCreated = Math.max(1, created - Math.floor(r() * 5))
      const stageChange = Math.floor(r() * oppCreated)
      const status = r() > 0.82 ? pick(['won', 'lost', 'abandoned']) : 'open'
      opportunities.push({
        id: `op_${i}`,
        name: `Oportunidad ${i}`,
        pipelineId: pipeline.id,
        pipelineStageId: stage.id,
        status,
        monetaryValue: Math.round((r() * 4000 + 200) / 50) * 50,
        assignedTo: pick(USUARIOS),
        contactId: id,
        source: pick(ORIGENES),
        contact: { id, name: `${contacts[i].firstName} ${contacts[i].lastName}`, email: contacts[i].email, phone: contacts[i].phone },
        createdAt: ago(oppCreated),
        updatedAt: ago(Math.min(stageChange, oppCreated)),
        lastStageChangeAt: ago(stageChange),
        lastStatusChangeAt: ago(stageChange),
      })
    }
  }

  return { pipelines: PIPELINES, contacts, opportunities }
}
